<template>
    <div class="page bg-blue relative desktop-footer">
        <div class="bg-head-coin sm:block"></div>
        <div class="page-content sm:px-8 flex flex-col min-h-screen">
            <NewTopbarBack class="sm:hidden" title="Home" :isShowOnlyLogo="true" :modalController="modalController"></NewTopbarBack>
            <Topbar title="none" :isShowOnlyLogo="true" :modalController="modalController"></Topbar>
            <div class="bg-white rounded-25 p-6 pb-3 mx-3 mt-7 mb-5 flex flex-col flex-grow">
                <div class="pb-5">
                    <PathLink :pathLink1="pathLink1" :pathLink2="pathLink2"></PathLink>
                </div>
                <div class="text-tc-blue-2 text-24 text-center">{{lbl.getfriend.fill_mobile}}</div>
                <div class="text-tc-gray-7 text-20 text-center pt-2">{{lbl.getfriend.invitations}}</div>
                <div class="px-1.5 mt-5 flex-grow">
                    <div class="text-tc-gray-3 text-20 mb-1.5">{{lbl.getfriend.contact_number}} <span class="text-a-red-eb1c24">*</span></div>
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-0 sm:gap-x-4">
                        <InputCollectPoint
                            v-model:inputValue="codes[i]"
                            v-for="(code, i) in codes"
                            :key="i"
                            :errorInfo="errorInfo[i]"
                            :inputIndex="i"
                            :inputLbl="lbl.collect_point.input"
                            :isShowError="isShowError"
                            :isShowRemove="i > 4"
                            :isSubmitted="isSubmitted"
                            :minLength="10"
                            :maxLength="12"
                            delimeter="-"
                            @onRemove="removeInput($event)" />
                        <div @click="addInput()"
                            class="flex items-center justify-center rounded-10 border border-dashed border-a-blue-1c3e95 sm:h-11">
                            <img class="h-6" src="../../../assets/fgf/fgf-plus.png" />
                            <div class="text-20 text-a-blue-1c3e95 py-2.5">{{lbl.getfriend.more_input}}</div>
                        </div>
                    </div>
                    <!-- <div v-for="(collectionCode , counter) in collectionCodes"
                        :key="counter">
                        <input type="tel"
                            maxlength="10"
                            class="w-full border bg-white px-3 py-2.5 placeholder-tc-gray-1 rounded-10 mb-4 text-20 text-a-blue-1c3e95"
                            :class="{'error': !isSubmit && codeError[counter]}"
                            v-model="collectionCodes[counter]"
                            :name='"code" + counter'
                            autocomplete="off"
                            placeholder='กรอกเบอร์โทรศัพท์'
                            @keypress="isNumber($event)"/>
                    </div> -->
                    <div class="flex">
                        <BlueBtn class="text-20 text-white mt-5 sm:w-80 mx-auto" @click="onSubmit()">{{lbl.getfriend.confirm_sms}}</BlueBtn>
                    </div>
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>

// helper
import { ErrorInfo, FormHelper } from '@/helper/FormHelper.js';
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
import LocaleMixin from '@/mixin/LocaleMixin.js';
import RegxHelper from '@/helper/RegxHelper'
//component
import NewTopbarBack from "@/components/Layout/TopBar/NewTopbarBack.vue"
import Topbar from '@/components/Layout/TopBar/TopBar.vue';
import BlueBtn from "@/components/Button/BlueBtn.vue";
import InputCollectPoint from "../component/InputCollectPoint.vue";
import MissionSerivce from '../service/MissionService';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
import PathLink from '../component/PathLink.vue'

export default ({
    name:'getfriendsms',
    mixins: [ModalMixin, LocaleMixin],
    components: {
        NewTopbarBack,
        BlueBtn,
        InputCollectPoint,
        BottomBar,
        Topbar,
        PathLink
    },
    computed: {
        currentInputAmount: function() {
            return this.codes.length;
        }
    },
    data: function () {
        return {
            minInputAmount: 5,
            maxInputAmount: 10,
            codes: ['','','','',''],
            errorInfo: [],
            isShowError: false,
            isSubmitted: false,
            pathLink1: {
                name: 'Friend Get Friend ชวนเพื่อนรับคะแนนเพิ่ม',
                url: '/getfriend/' + this.$route.params.key
            },
            pathLink2: {
                name: 'ชวนเพื่อนผ่าน SMS',
                url: ''
            }
        }
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(5);
        this.pathLink1.name = this.lbl.getfriend.friend_get_friend
        this.pathLink2.name = this.lbl.getfriend.invite_friend_sms
    },
    methods: {
        isNumber: function(evt) {
            if (!/\d/.test(evt.key)) return evt.preventDefault();
        },
        //#region input
        addInput: function(newCode) {
            if (this.currentInputAmount == this.maxInputAmount) return;

            let code = newCode || "";
            // add code
            this.codes.push(code);
            // add error
            const errorInfoItem = new ErrorInfo();
            this.errorInfo.push(errorInfoItem);
        },
        removeInput: function(index) {
            if (this.currentInputAmount == this.minInputAmount) return;

            // remove code
            this.codes.splice(index, 1);
            // remove code
            this.errorInfo.splice(index, 1);
        },
        onSubmit: function () {
            this.isSubmitted = true;
            this.isShowError = true;
            // Check input error.
            const isValid = FormHelper.validate(this.errorInfo);
            if(isValid){
                let numberPhone = [];
                for(let i of this.codes){
                    if(i){
                        numberPhone.push(RegxHelper.removeNotNumber(i))
                    }
                }
                let params = {
                    contactNumberJson: JSON.stringify(numberPhone)
                }
                this.loadingModal.show();
                return new Promise((resolve) => {
                    MissionSerivce.inviteSms(params)
                        .subscribe ({
                            next: (res) => {
                                console.log(res)
                                this.loadingModal.hide();
                                if(this.codes.length == 10){
                                    this.modalController.successModal
                                    .setTitle(this.lbl.getfriend.congratulation)
                                    .setMsg(this.lbl.getfriend.invite_full)
                                    .show();
                                }else{
                                    this.modalController.successModal
                                    .setTitle(this.lbl.getfriend.invite_success)
                                    .show();
                                }

                                this.modalController.successModal.onClickOk(() => {
                                    this.$router.push('/mission')
                                });
                                resolve(true);
                            },
                            error: (err) => {
                                resolve(false);
                                this.loadingModal.hide();
                                this.errorApi(err);
                            }
                        })
                });
            }
        }
    }
})
</script>
